import { render, staticRenderFns } from "./RewardPlans.vue?vue&type=template&id=11269b5f&scoped=true&"
import script from "./RewardPlans.vue?vue&type=script&lang=ts&"
export * from "./RewardPlans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11269b5f",
  null
  
)

export default component.exports